(ns motorsaif.web.components.request-listing
  (:require
   [motorsaif.log :as log]
   [motorsaif.web.components :as c]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.web.photos :as photos]
   [motorsaif.string :refer [format]]
   [motorsaif.time :as time]
   [motorsaif.utils :as utils]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

(defn request-listing [request]
  (let [{request-id :db/id
         created :date-time/created
         short-id :short/id
         {owner-id :db/id :as owner} :owner
         :request/keys [object media description category type]} request
        {:car/keys [year make model]} object
        handle (utils/owner-handle owner)
        biz? (:business/name owner)]
    [:a
     {:href (routes/path-for :request {:id short-id})}
     [:div.request-listing
      [:div.admin-actions
       (when @(subscribe [:admin-overlay])
         [:button.btn.primary
          {:on-click #(log/info [:implement])}
          "Close"])]
      [:div.post-profile.clr-neutral-1
       [c/avatar-letter-with-handle {:owner owner
                                     :no-link true
                                     :posted created}]]
      [:div.content
       [:div.tag.primary (:tag/title category)]
       (when (seq media)
       ^{:key (str (map :db/id media))}
         [photos/carousel {:media media}])
       [:div.text.car.bold (format "%s %s %s" year make model)]
       [:p.desc.clr-neutral-1.text.fw-500 description]]]]))
